module.exports = __webpack_public_path__ + "img/book-open-01.ab4fb470.svg";